class FeaturedCollectionSlider {
  constructor(container, sectionId) {
    this.container = container;
    this.sectionId = sectionId;
    this.slider = this.container.querySelector('.featured-collection__slider');
    this.prevButton = this.container.querySelector(`.featured-collection__slider-button--previous-${this.sectionId}`);
    this.nextButton = this.container.querySelector(`.featured-collection__slider-button--next-${this.sectionId}`);
    this.products = this.container.querySelectorAll('.featured-collection__product');

    this.currentIndex = 0;
    this.productsPerView = this.calculateProductsPerView();

    this.init();
  }

  init() {
    this.prevButton.addEventListener('click', () => this.slide('prev'));
    this.nextButton.addEventListener('click', () => this.slide('next'));
    window.addEventListener('resize', () => {
      this.productsPerView = this.calculateProductsPerView();
      this.updateButtonsVisibility();
    });

    this.updateButtonsVisibility();
  }

  calculateProductsPerView() {
    const containerWidth = this.slider.offsetWidth;
    const productWidth = this.products[0].offsetWidth;
    return Math.floor(containerWidth / productWidth);
  }

  slide(direction) {
    if (direction === 'prev' && this.currentIndex > 0) {
      this.currentIndex--;
    } else if (direction === 'next' && this.currentIndex < this.products.length - this.productsPerView) {
      this.currentIndex++;
    }

    const offset = this.products[this.currentIndex].offsetLeft;
    this.slider.scrollTo({
      left: offset,
      behavior: 'smooth',
    });

    this.updateButtonsVisibility();
  }

  updateButtonsVisibility() {
    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = this.currentIndex >= this.products.length - this.productsPerView;
  }
}
